var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 230,
    viewBox: "0 0 205 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 204,
    height: 229,
    rx: 4.5,
    stroke: "#475569",
    strokeDasharray: "4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 175,
    height: 26,
    rx: 4.5,
    stroke: "#475569",
    strokeDasharray: "4 4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 189.5,
    width: 175,
    height: 26,
    rx: 4.5,
    stroke: "#475569",
    strokeDasharray: "4 4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 129,
    width: 79,
    height: 19,
    rx: 5,
    fill: "#475569",
    fillOpacity: 0.29
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 50.5,
    width: 175,
    height: 129,
    rx: 4.5,
    stroke: "#475569",
    strokeDasharray: "4 4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 75.7384,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(45 102 75.7384)",
    stroke: "#475569"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5301 92.0032L107.53 92.0046M102.529 87.0039L102.531 97.0038",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTemplate);
export default __webpack_public_path__ + "static/media/design_template.e295faa1ea5c72c8bb2254df24edccc0.svg";
export { ForwardRef as ReactComponent };